import { HtmlRenderer, Parser } from 'commonmark'

import * as React from 'react';
import { Link } from 'react-router';
import { commonStingManagerManager } from '../../api/commonStingManagerManager';

import EventItem from '../../api/eventItemEntity';
import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';
import { LatestEventsListBlockContainer } from '../latestEventsListBlock/latestEventsListBlockContainer';

interface IProps {
    eventItemId: string;
    eventItem: EventItem;
    fetchEventItemById(id: string): void;
}

export class EventPage extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchEventItemById(this.props.eventItemId);
  }

  public componentWillReceiveProps (nextProps: IProps) {
    if(nextProps.eventItemId !== this.props.eventItemId) {
      // Clean component and reload
      this.props.fetchEventItemById(nextProps.eventItemId);
    }
 }

  public render() {
    const parser = new Parser()
    const renderer = new HtmlRenderer()
    const content = renderer.render(parser.parse(this.props.eventItem.body))

    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="content">
                            <h1>{this.props.eventItem.title}</h1>
                            <div className="event-info">
                                <strong>Aika: </strong>{commonStingManagerManager.formatDateToFiCulture(this.props.eventItem.eventDate)}<br />
                                <strong>Paikka: </strong>{this.props.eventItem.eventPlace.address}<br />
                                <strong>Järjestäjä: </strong>{this.props.eventItem.eventPlace.title}
                            </div>
                            <img src={this.props.eventItem.eventImage} className="align-right" />
                            <p dangerouslySetInnerHTML={ {__html: content} } />

                            <Link to={`/ajankohtaista`} className="back">Kaikki ajankohtaiset</Link>

                            <LatestEventsListBlockContainer />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/eventPage/eventPage.tsx